import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { Collapse } from '@zola/zola-ui/src/components/Collapse';

import type { RootState } from 'reducers/index';

import { getUserContext } from 'selectors/user';
import getMobileUtilityLinks, {
  accountSettingsPaths,
} from 'components/MobileNavV3/MobileNavMenu/MobileNavMenuData/mobileNavData/getMobileUtilityLinks';

import {
  List,
  ListItem,
  StyledLinkV2,
  Title,
  ChildrenList,
  StyledCaretIcon,
} from './MobileNavUtilityLinks.styles';

const MobileNavUtilityLinks = (): JSX.Element => {
  const [accountSettingsOpen, setAccountSettingsOpen] = useState(
    accountSettingsPaths.includes(window.location.pathname)
  );
  const userContext = useSelector((state: RootState) => getUserContext(state));
  const utilityLinks = getMobileUtilityLinks(userContext);

  return (
    <List>
      {utilityLinks.map(({ title, path, icon, rel, target, children }) => {
        const hasChildren = (children?.length || 0) > 0;
        const handleClick = (e: React.MouseEvent<Element>) => {
          if (hasChildren) {
            e.preventDefault();
            setAccountSettingsOpen(!accountSettingsOpen);
          }
        };
        return (
          <ListItem key={path}>
            <StyledLinkV2
              href={path}
              rel={rel}
              target={target}
              variant="primary"
              sizes="small"
              bold
              onClick={handleClick}
              noUnderline
            >
              {icon} <Title>{title}</Title>
              {hasChildren && <StyledCaretIcon direction={accountSettingsOpen ? 'up' : 'down'} />}
            </StyledLinkV2>
            {hasChildren && (
              <Collapse isOpen={accountSettingsOpen}>
                <ChildrenList>
                  {children?.map((child) => (
                    <ListItem key={child.path}>
                      <StyledLinkV2
                        href={child.path}
                        target="_self"
                        sizes="small"
                        bold
                        noUnderline
                        inline
                      >
                        {child.title}
                      </StyledLinkV2>
                    </ListItem>
                  ))}
                </ChildrenList>
              </Collapse>
            )}
          </ListItem>
        );
      })}
    </List>
  );
};

export default MobileNavUtilityLinks;
